import { Component, input } from '@angular/core';

@Component({
  selector: 'app-section-card',
  standalone: true,
  template: `
    <section class="section-card">
      <header class="section-card-header">
        <div class="section-card-titles">
          <h2 class="section-card-title">{{ title() }}</h2>
          @if (subtitle(); as sub) {
            <p class="section-card-subtitle">{{ sub }}</p>
          }
        </div>
        <div class="section-card-actions">
          <ng-content select="[sectionCardActions]"></ng-content>
        </div>
      </header>
      <div class="section-card-content">
        <ng-content></ng-content>
      </div>
    </section>
  `,
  styles: [
    `
      .section-card {
        border: 1px solid var(--border-subtle);
        border-radius: var(--r-card);
        background: var(--bg-surface);
        box-shadow: var(--shadow-sm);
        padding: var(--space-5) var(--space-5);
        display: flex;
        flex-direction: column;
        gap: var(--space-4);
        min-height: 0;
      }

      .section-card-header {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: var(--space-3);
      }

      .section-card-titles {
        min-width: 0;
        display: flex;
        flex-direction: column;
        gap: 4px;
      }

      .section-card-title {
        margin: 0;
        font: var(--font-section-label);
        text-transform: uppercase;
        letter-spacing: 0.07em;
        color: var(--muted);
      }

      .section-card-subtitle {
        margin: 0;
        font-size: 13px;
        font-weight: 500;
        color: var(--faint);
        line-height: 1.4;
      }

      .section-card-actions:empty {
        display: none;
      }

      .section-card-content {
        min-height: 0;
        flex: 1;
      }
    `,
  ],
})
export class SectionCardComponent {
  readonly title = input.required<string>();
  readonly subtitle = input<string | null>(null);
}
